import { Component, OnInit,Inject } from '@angular/core';
import {MdDialog, MdDialogRef, MD_DIALOG_DATA} from '@angular/material';

@Component({
  selector: 'app-getdevdetail',
  templateUrl: './getdevdetail.component.html',
  styleUrls: ['./getdevdetail.component.scss']
})
export class GetdevdetailComponent implements OnInit {

  constructor(public dialogRef: MdDialogRef<GetdevdetailComponent>,
    @Inject(MD_DIALOG_DATA) public data: any) {
      console.log(data);
      if(data.Type == "idel"){
        this.vechtype = "Ideals Vechiles"
      }
      else if(data.Type == "stop"){
        this.vechtype = "Stopped Vechiles"
      }
      else if(data.Type == "maintain"){
        this.vechtype = "Maintainence Vechiles"
      }
      else if(data.Type == "outoff"){
        this.vechtype = "Out off Reach Vechiles"
      }
     }
     vechtype:any;

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/vtrackOneqlik/oneqlik_wetrack/src/app/const/getdevdetail/getdevdetail.component.ts